import {
  Card,
  CardContent,
  CardMedia,
  createStyles,
  makeStyles,
  Paper,
  Theme,
} from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import React, { useEffect, useState } from 'react'

import { DoseList } from '../../components'
import { ICircle, IDose } from 'daily-dose-common'
import { firestore } from '../../firebase-init'
import * as Utilities from '../../utilities'
import circleDefaultImage from '../../assets/images/circle.png'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      backgroundColor: theme.palette.background.paper,
    },
    media: {
      height: 250,
    },
    membersContainer: {
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(1),
      '& > *:not(:first-child)': {
        marginLeft: theme.spacing(0.5),
      },
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
  })
)

export interface IMyCircleDetailPage<P> {
  match: IMatch<P>
  location: any
  history: any
  staticContext?: any
}

export interface IMatch<P> {
  params: P
  isExact: boolean
  path: string
  url: string
}

interface IMatchParams {
  id: string
}

const PastDosesPages = (route: IMyCircleDetailPage<IMatchParams>) => {
  const classes = useStyles()
  const [circle, setCircle] = useState({} as ICircle)
  const [doses, setDoses] = useState([] as IDose[])

  const circleId = route.match.params.id
  const circleRef = firestore.collection('circles').doc(circleId)
  const dosesRef = circleRef.collection('doses')
  const finishedDoses = dosesRef
    .where('status', '==', 'finished')
    .orderBy('activeAt', 'desc')

  // TODO: We might not need snapshots because it could be very expensive to fetch evety time somebody changes something.
  // TODO: Use get() instead of onSnapshot
  useEffect(() => {
    const unsubscribeFromCircle = circleRef.onSnapshot((snapshot) => {
      const circle = Utilities.collectIdAndDocs(snapshot)
      setCircle(circle)
    })

    const unsubscribeFromDoses = finishedDoses.onSnapshot((snapshot) => {
      const doses = snapshot.docs.map(Utilities.collectIdAndDocs)
      setDoses(doses)
    })

    return () => {
      unsubscribeFromCircle()
      unsubscribeFromDoses()
    }
    // eslint-disable-next-line
  }, [])

  return (
    <Paper style={{ overflow: 'auto' }}>
      <Card className={classes.root}>
        <CardMedia
          className={classes.media}
          image={circle.photoURL || circleDefaultImage}
          title={circle.name}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            {circle.name}
          </Typography>
          <Typography variant="h5" color="textSecondary" component="h2" gutterBottom>
            Past Doses
          </Typography>
          {doses.length > 0 ? (
            <DoseList doses={doses} orderBy="activeAt" mode="desc" />
          ) : (
            <Typography>No doses have finished yet</Typography>
          )}
        </CardContent>
      </Card>
    </Paper>
  )
}

export default PastDosesPages
